<p-tabMenu class="tabs-menu" [model]="tabs" [activeItem]="activeItem">
  <ng-template class="aa" pTemplate="item" let-item let-i="index">
    <div [pTooltip]="item.enableTooltip ? COMING_SOON_TEXT : null" tooltipPosition="bottom" class="tabs-style">{{ item.label }}</div>
  </ng-template>
</p-tabMenu>
